import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const HeroRoot = styled('div', {
  width: '100%',
  background: '$primary-450',

  '& .desktop-only': {
    display: 'none',
  },
  '& .mobile-only': {
    display: 'block',
  },

  '@bp3': {
    '& .desktop-only': {
      display: 'flex',
    },
    '& .mobile-only': {
      display: 'none',
    },
  },
})

export const ContentWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column-reverse',
  alignItems: 'center',
  margin: 'auto',

  '@bp3': {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    maxWidth: '1920px',
  },
})

export const QuoteWrapper = styled('div', {
  width: '100%',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: 'auto',
  maxWidth: '320px',
  marginBottom: '$5',
  marginTop: '$4',
  '@bp3': {
    width: '50%',
    margin: 'auto',
    textAlign: 'left',
    maxWidth: '800px',
    paddingLeft: '$2',
    paddingRight: '$2',
  },
})

export const ImageWrapper = styled('div', {
  position: 'relative',

  width: '100%',
  maxWidth: '381px',
  margin: 'auto',
  height: '370px',
  '& img': {
    objectPosition: '40% 0%',
  },

  '@bp3': {
    width: '50%',
    maxWidth: '922px',
    height: '450px',
    '& img': { objectPosition: '30% 0%' },
  },
})

export const Description = styled(Text, {
  marginTop: '$2',
  marginBottom: '$5',
  maxWidth: '300px',

  '@bp3': {
    marginTop: '$2',
    marginBottom: '$2',
    maxWidth: '450px',
  },

  '@bp4': {
    marginTop: '$4',
    marginBottom: '$4',
    maxWidth: '100%',
  },
})

export const Span = styled('span', {
  fontSize: '$body',
  fontWeight: '$medium',
})
